{
  "PROFILE_SETTINGS": {
    "LINK": "Podešavanja profila",
    "TITLE": "Podešavanja profila",
    "BTN_TEXT": "Izmeni profil",
    "DELETE_AVATAR": "Obriši avatar",
    "AVATAR_DELETE_SUCCESS": "Avatar je uspešno obrisan",
    "AVATAR_DELETE_FAILED": "Pojavila se greška pri brisanju avatara, molim vas pokušajte ponovo",
    "UPDATE_SUCCESS": "Vaš profil je uspešno izmenjen",
    "PASSWORD_UPDATE_SUCCESS": "Vaša lozinka je uspešno promenjena",
    "AFTER_EMAIL_CHANGED": "Vaš profil je uspešno izmenjen, molim vas prijavite se ponovo jer su vaši kredencijali za prijavu izmenjeni",
    "FORM": {
      "PICTURE": "Profile Picture",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Слика за потпис е-поште",
        "HINT": "Користи се у потписима е-поште. {'{{'}email_signature_picture{'}}'} се замењује URL-ом ове слике (а не ознаком слике) — употребите га као извор слике (атрибут src img ознаке) у свом потпису или потпису сандучета. Ако није постављена, ништа се не умеће.",
        "DELETE_SUCCESS": "Слика за потпис е-поште је успешно избрисана",
        "DELETE_FAILED": "Дошло је до грешке приликом брисања слике за потпис е-поште, покушајте поново"
      },
      "AVATAR": "Slika profila",
      "ERROR": "Molim vas ispravite greške formulara",
      "REMOVE_IMAGE": "Ukloni",
      "UPLOAD_IMAGE": "Dodaj sliku",
      "UPDATE_IMAGE": "Izmeni sliku",
      "PROFILE_SECTION": {
        "TITLE": "Profil",
        "NOTE": "Vaša adresa e-pošte je vaš identitet i koristi se za prijavu."
      },
      "SEND_MESSAGE": {
        "TITLE": "Hotkey to send messages",
        "NOTE": "You can select a hotkey (either Enter or Cmd/Ctrl+Enter) based on your preference of writing.",
        "UPDATE_SUCCESS": "Your settings have been updated successfully",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Send messages by pressing Enter key instead of clicking the send button."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Send messages by pressing Cmd/Ctrl + enter key instead of clicking the send button."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Prilagodite izgled svoje radne table.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Predefinisano",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Jezik radne table",
          "NOTE": "Zamenite jezik naloga za vašu ličnu radnu tablu. Ostavite prazno da koristite podrazumevani jezik naloga.",
          "USE_ACCOUNT_DEFAULT": "Koristi podrazumevano sa naloga",
          "API_SUCCESS": "Jezik vaše radne table je uspešno ažuriran"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Jezik poruke",
          "NOTE": "Izaberite da li da prikazujete originalne poruke ili njihove prevode",
          "ORIGINAL": "Original",
          "TRANSLATED": "Prevedeno"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Ponašanje pri lepljenju",
          "NOTE": "Izaberite kako se nalepljeni sadržaj obrađuje prilikom sastavljanja poruka",
          "UPDATE_SUCCESS": "Vaša podešavanja lepljenja su uspešno ažurirana",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Zadrži sve formatiranje",
              "DESCRIPTION": "Zadržite sve formatiranje, uključujući tabele, stilove i druge HTML elemente prilikom lepljenja sadržaja."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Samo tekst sa vezama",
              "DESCRIPTION": "Pretvorite u običan tekst, ali zadržite veze na koje se može kliknuti prilikom lepljenja sadržaja."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Samo običan tekst",
              "DESCRIPTION": "Uklonite sve formatiranje i pretvorite u običan tekst prilikom lepljenja sadržaja."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Visina polja za odgovor",
          "NOTE": "Podesite minimalnu visinu polja za odgovor kao procenat visine ekrana. Važi samo za razgovore putem e-pošte.",
          "UPDATE_SUCCESS": "Podešavanje visine polja za odgovor je uspešno ažurirano",
          "PERCENT_LABEL": "Visina (% visine ekrana)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Predefinisano",
              "DESCRIPTION": "Polje za odgovor je u početku malo i raste dok kucate."
            },
            "CUSTOM": {
              "HEADING": "Prilagođeno",
              "DESCRIPTION": "Polje za odgovor uvek zauzima najmanje izabrani procenat visine ekrana."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Automatski pređi na sledeći razgovor",
        "NOTE": "Automatski pređite na sledeći otvoreni razgovor nakon rešavanja trenutnog",
        "UPDATE_SUCCESS": "Podešavanje automatske navigacije je uspešno ažurirano"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Potpis privatne poruke",
        "DESCRIPTION": "Napravite jedinstven potpis poruke koji će se prikazivati na kraju svake e-poruke koju pošaljete. Možete uključiti i sliku unutar teksta.",
        "NOTE": "Create a unique message signature to appear at the end of every message you send from any inbox. You can also include an inline image, which is supported in live-chat, email, and API inboxes.",
        "BTN_TEXT": "Sačuvaj potpis poruke",
        "API_ERROR": "Nije bilo moguće sačuvati potpis! Pokušajte ponovo",
        "API_SUCCESS": "Potpis je uspešno sačuvan",
        "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
        "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save to save the signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Potpis poruke",
        "ERROR": "Potpis poruke ne može biti prazan",
        "PLACEHOLDER": "Unesite ovde vaš potpis lične poruke."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Lozinka",
        "NOTE": "Izmena lozinke će resetovati vaše prijave na više uređaja.",
        "BTN_TEXT": "Promeni lozinku"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Token za pristup",
        "NOTE": "Ovaj token se može koristiti ako izgrađujete integraciju zasnovanu na API-ju",
        "COPY": "Kopiraj",
        "REGENERATE": "Ponovo generiši",
        "REGENERATE_SUCCESS": "Token za pristup je uspešno ponovo generisan. Ažurirajte sve integracije koje koriste stari token.",
        "REGENERATE_CONFIRM_TITLE": "Ponovo generisati token za pristup?",
        "REGENERATE_CONFIRM_MESSAGE": "Ovim će trenutni token postati nevažeći. Sve integracije koje koriste stari token prestaće da rade."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Chrome ekstenzija",
        "NOTE": "Instalirajte našu Chrome ekstenziju da biste dobijali detaljna obaveštenja o dolaznim telefonskim pozivima.",
        "INSTALL_BUTTON": "Instaliraj ekstenziju",
        "ALREADY_INSTALLED": "Ekstenzija je instalirana"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "Niko",
          "MINE": "Assigned",
          "ALL": "Sve",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "Niko",
          "ASSIGNED": "Dodeljeni razgovori",
          "ALL_CONVERSATIONS": "Svi razgovori"
        },
        "DEFAULT_TONE": {
          "TITLE": "Alert tone:"
        },
        "CONDITIONS": {
          "TITLE": "Alert conditions:",
          "CONDITION_ONE": "Send audio alerts only if the browser window is not active",
          "CONDITION_TWO": "Send alerts every 10s until all the assigned conversations are read"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Read more"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Obaveštenja e-porukom",
        "NOTE": "Ovde izmenite podešavanja obaveštenja putem e-pošte",
        "CONVERSATION_ASSIGNMENT": "Pošalji obaveštenje putem e-poruke kada je razgovor dodeljen meni",
        "CONVERSATION_CREATION": "Pošalji obaveštenje putem e-poruke kada je napravljen novi razgovor",
        "CONVERSATION_MENTION": "Pošalji obaveštenje putem e-poruke kada ste pomenuti u razgovoru",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Pošalji obaveštenje putem e-poruke kada je napravljena nova poruka u dodeljenom razgovoru",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in a participating conversation",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "E-pošta",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Nova poruka je napravljena u razgovoru bez dostupnog agenta",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Дозволи push обавештења током позива",
        "TEST_PUSH": "Test",
        "TESTING": "Testiranje...",
        "TEST_PUSH_DESCRIPTION": "Pošaljite probna obaveštenja da biste proverili podešavanje",
        "TEST_NOTIFICATION_ERROR": "Nije uspelo slanje probnog obaveštenja. Pokušajte ponovo.",
        "TEST_LOCAL_TITLE": "Probno obaveštenje (lokalno)",
        "TEST_LOCAL_BODY": "Ovo je lokalno obaveštenje pregledača. Ako vidite ovo, obaveštenja pregledača rade!"
      },
      "API": {
        "UPDATE_SUCCESS": "Vaša podešavanja obaveštenja su uspešno izmenjena",
        "UPDATE_ERROR": "Pojavila se greška pri izmeni podešavanja, molim vas pokušajte ponovo"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Mobilna obaveštenja",
        "NOTE": "Ovde izmenite vaša podešavanja mobilnih obaveštenja",
        "CONVERSATION_ASSIGNMENT": "Pošalji mobilno obaveštenje kada je razgovor dodeljen meni",
        "CONVERSATION_CREATION": "Pošalji mobilno obaveštenje kada je napravljen novi razgovor",
        "CONVERSATION_MENTION": "Pošalji mobilno obaveštenje kada ste pomenuti u razgovoru",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Pošalji mobilno obaveštenje kada je napravljena nova poruka u dodeljenom razgovoru",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in a participating conversation",
        "HAS_ENABLED_PUSH": "Omogućili ste obaveštenje za ovaj pregledač.",
        "REQUEST_PUSH": "Omogućite mobilna obaveštenja",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Slika profila"
      },
      "NAME": {
        "LABEL": "Vaše puno ime",
        "ERROR": "Molimo unesite ispravno puno ime",
        "PLACEHOLDER": "Molimo unesite vaše puno ime"
      },
      "DISPLAY_NAME": {
        "LABEL": "Ime za prikaz",
        "ERROR": "Molimo unesite ispravno ime za prikaz",
        "PLACEHOLDER": "Molim vas unesite ime za prikaz, ovo će biti prikazano u razgovorima"
      },
      "POSITION": {
        "LABEL": "Pozicija",
        "ERROR": "Unesite ispravnu poziciju",
        "PLACEHOLDER": "Unesite svoju poziciju"
      },
      "CUSTOM_LINE": {
        "LABEL": "Prilagođena linija",
        "ERROR": "Unesite ispravnu prilagođenu liniju",
        "PLACEHOLDER": "Unesite svoju prilagođenu liniju"
      },
      "AVAILABILITY": {
        "LABEL": "Dostupnost",
        "STATUS": {
          "ONLINE": "Dostupan",
          "BUSY": "Zauzet",
          "OFFLINE": "Nedostupan"
        },
        "SET_AVAILABILITY_SUCCESS": "Availability has been set successfully",
        "SET_AVAILABILITY_ERROR": "Couldn't set availability, please try again"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Format prikaza pregleda e-pošte u listi razgovora",
        "NOTE": "Izaberite šta se prikazuje u listi razgovora za razgovore iz sandučića e-pošte",
        "SUBJECT": "Naslov",
        "SUBJECT_WITH_NOTE": "Naslov i poslednja poruka ako je interna beleška",
        "UPDATE_SUCCESS": "Podešavanje pregleda e-pošte je uspešno ažurirano"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Onemogući prečice na tastaturi",
        "NOTE": "Isključite sve prečice na tastaturi u čitavoj aplikaciji",
        "UPDATE_SUCCESS": "Podešavanje prečica na tastaturi je uspešno ažurirano"
      },
      "FOLDER_ORDER": {
        "TITLE": "Redosled foldera",
        "NOTE": "Prilagodite redosled kojim se folderi (prilagođeni prikazi) pojavljuju u bočnoj traci. Prevucite i otpustite da promenite redosled.",
        "NO_FOLDERS": "Nisu pronađeni prilagođeni folderi. Napravite foldere da biste organizovali svoje razgovore."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Podešavanje bočne trake",
        "NOTE": "Prilagodite koji delovi se prikazuju u bočnoj traci razgovora.",
        "SAVE_BUTTON": "Sačuvaj podešavanja",
        "UPDATE_SUCCESS": "Podešavanje bočne trake je uspešno ažurirano",
        "UPDATE_ERROR": "Došlo je do greške prilikom ažuriranja podešavanja bočne trake, pokušajte ponovo",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Svi razgovori",
          "ALL_CONVERSATIONS_DESC": "Prikaži stavku menija Svi razgovori u bočnoj traci",
          "INBOX": "Sanduče",
          "INBOX_DESC": "Prikaži glavno sanduče sa nepročitanim obaveštenjima",
          "CONVERSATION_GROUPS": "Spominjanja i nedodeljeni",
          "CONVERSATION_GROUPS_DESC": "Prikaži grupe razgovora Spominjanja i Nedodeljeni",
          "FOLDERS": "Folderi",
          "FOLDERS_DESC": "Prikaži prilagođene prikaze (foldere) za organizovane razgovore",
          "TEAMS": "Timovi",
          "TEAMS_DESC": "Prikaži razgovore filtrirane po dodeljenom timu",
          "CHANNELS": "Sandučad",
          "CHANNELS_DESC": "Prikaži razgovore filtrirane po sandučetu",
          "LABELS": "Oznake",
          "LABELS_DESC": "Prikaži razgovore filtrirane po oznakama"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Podešavanja telefona",
        "NOTE": "Unesite podatke za prijavu na vaš PBX sistem.",
        "USERNAME": "Korisničko ime",
        "PASSWORD": "Lozinka",
        "SUBMIT": "Sačuvaj",
        "USERNAME_INVALID": "Korisničko ime može sadržati samo slova, cifre i . _ - + — bez razmaka i bez adrese e-pošte.",
        "API": {
          "USERNAME_INVALID": "Korisničko ime nije ispravno SIP korisničko ime. Koristite samo slova, cifre i . _ - + — bez razmaka i bez adrese e-pošte.",
          "USERNAME_TAKEN": "Ovo korisničko ime već koristi drugi agent na ovom nalogu."
        }
      },
      "EMAIL": {
        "LABEL": "Vaša adresa e-pošte",
        "ERROR": "Molim vas unesite ispravnu adresu e-pošte",
        "PLACEHOLDER": "Molim vas unesite adresu e-pošte, ovo će biti prikazano u razgovorima"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Trenutna lozinka",
        "ERROR": "Molim vas unesite trenutnu lozinku",
        "PLACEHOLDER": "Molim vas unesite trenutnu lozinku"
      },
      "PASSWORD": {
        "LABEL": "Nova lozinka",
        "ERROR": "Molim vas unesite lozinku od 6 karaktera ili dužu",
        "PLACEHOLDER": "Molim vas unesite novu lozinku"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Potvrdite novu lozinku",
        "ERROR": "Potvrdna lozinka bi trebala da se poklapa sa lozinkom",
        "PLACEHOLDER": "Molim vas ponovo unesite novu lozinku"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Promeni",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Prijavi grešku",
    "SELECTOR_SUBTITLE": "Izaberite nalog iz sledećeg spiska",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Prijavi grešku",
    "DESCRIPTION_LABEL": "Opis problema",
    "DESCRIPTION_PLACEHOLDER": "Opišite problem na koji ste naišli...",
    "SUBMIT": "Pošalji prijavu",
    "SUBMITTING": "Slanje...",
    "CANCEL": "Otkaži",
    "SUCCESS": "Prijava greške je uspešno poslata. Hvala vam!",
    "VALIDATION_ERROR": "Opišite problem pre slanja"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "dana preostalo od probnog perioda.",
    "TRAIL_BUTTON": "Kupi sada",
    "DELETED_USER": "Obrisan korisnik",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Nalog je suspendovan",
      "MESSAGE": "Vaš nalog je suspendovan. Molim vas kontaktirajte tim za podršku za dodatne informacije."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopiraj",
      "CODEPEN": "Open in CodePen",
      "COPY_SUCCESSFUL": "Kod je uspešno kopiran na beležnicu"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Prikaži više",
      "SHOW_LESS": "Prikaži manje"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Preuzmi",
      "UPLOADING": "Dodavanje...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Ova priča više nije dostupna.",
      "RECORDING_UNAVAILABLE": "Ovaj snimak više nije dostupan.",
      "DELETE_RECORDING": {
        "BUTTON": "Obriši snimak poziva",
        "TITLE": "Obrisati snimak poziva?",
        "DESCRIPTION": "Svi snimci ovog poziva biće trajno obrisani sa telefonske centrale i neće se moći povratiti. Transkript i rezime poziva ostaju.",
        "CONFIRM": "Obriši",
        "SUCCESS": "Snimak poziva je obrisan",
        "ERROR": "Snimak poziva nije bilo moguće obrisati. Pokušajte ponovo."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "See on map"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Pošalji"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Proveravanje...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Dodaj prijemno sanduče"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Trenutno pregledate:",
    "SWITCH": "Prebaci",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Razgovori",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Svi razgovori",
    "MENTIONED_CONVERSATIONS": "Spominjanja",
    "PARTICIPATING_CONVERSATIONS": "Participating",
    "UNATTENDED_CONVERSATIONS": "Nedodeljeni",
    "REPORTS": "Izveštaji",
    "SETTINGS": "Podešavanja",
    "CONTACTS": "Kontakti",
    "DATA_ASSISTANT": "Asistent za podatke",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Početak",
    "AGENTS": "Agenti",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Audit Logs",
    "WHATSAPP_TEMPLATES": "WhatsApp šabloni",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Prijemni sandučići",
    "NOTIFICATIONS": "Obaveštenja",
    "CANNED_RESPONSES": "Gotovi odgovori",
    "INTEGRATIONS": "Integracije",
    "PROFILE_SETTINGS": "Podešavanja profila",
    "ACCOUNT_SETTINGS": "Podešavanja naloga",
    "APPLICATIONS": "Aplikacije",
    "LABELS": "Oznake",
    "CUSTOM_ATTRIBUTES": "Prilagođeni atributi",
    "AUTOMATION": "Automatizacija",
    "MACROS": "Macros",
    "TEAMS": "Timovi",
    "BILLING": "Plaćanje",
    "CUSTOM_VIEWS_FOLDER": "Fascikle",
    "CUSTOM_VIEWS_SEGMENTS": "Segmenti",
    "ALL_CONTACTS": "Svi kontakti",
    "TAGGED_WITH": "Označeni sa",
    "NEW_LABEL": "Nova oznaka",
    "NEW_TEAM": "Novi tim",
    "NEW_INBOX": "Novo prijemno sanduče",
    "REPORTS_CONVERSATION": "Razgovori",
    "CSAT": "Izveštaj o zadovoljstvu",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Kampanje",
    "ONGOING": "Dugotrajne",
    "ONE_OFF": "Jednokratne",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agenti",
    "REPORTS_LABEL": "Oznake",
    "REPORTS_INBOX": "Prijemno sanduče",
    "REPORTS_TEAM": "Tim",
    "REPORTS_PHONE": "Telefon",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Pregled",
    "WALLBOARD_QUEUES": "Redovi čekanja",
    "DATA_ASSISTANT_CHAT": "Ćaskanje",
    "DATA_ASSISTANT_REPORTS": "Izveštaji",
    "NO_WAITING_CALLERS": "nema pozivalaca na čekanju",
    "WAITING_CALLERS": "{count} pozivalaca čeka",
    "SET_AVAILABILITY_TITLE": "Postavite da ste",
    "SET_YOUR_AVAILABILITY": "Podesite vašu dostupnost",
    "AVAILABILITY_IMPERSONATING": "Закључано док сте пријављени као овај корисник",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Novi razgovor",
    "DRAFT": "Nacrt",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Pregled",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Help Center",
      "ARTICLES": "Articles",
      "CATEGORIES": "Categories",
      "LOCALES": "Locales",
      "SETTINGS": "Podešavanja",
      "DICTIONARY": "Rečnik"
    },
    "CHANNELS": "Channels",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Mark offline automatically",
      "INFO_TEXT": "Let the system automatically mark you offline when you aren't using the app or dashboard.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Pročitaj dokumentaciju"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Blokirani domeni i kontakti",
    "DESCRIPTION": "Lista blokiranih domena e-pošte za ovaj nalog.",
    "NO_BLOCKED_DOMAINS": "Nema pronađenih blokiranih domena.",
    "BLOCKED_CONTACTS_BTN": "Blokirani kontakti"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Plaćanje",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Trenutni plan",
      "PLAN_NOTE": "Trenutno ste pretplaćeni na **{plan}** plan sa **{quantity}** licenci",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Upravljate vašom pretplatom",
      "DESCRIPTION": "Pregledajte vaše prethodne račune, izmenite podatke o plaćanju ili prekinite vašu pretplatu.",
      "BUTTON_TXT": "Idite na portal za plaćanje"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Treba vam pomoć?",
      "DESCRIPTION": "Da li imate probleme sa plaćanjem? Ovde smo da bi vam pomogli.",
      "BUTTON_TXT": "Razgovarajte sa nama"
    },
    "NO_BILLING_USER": "Vaš nalog za plaćanje se podešava. Molim vas osvežite stranicu i pokušajte ponovo."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "O ne! Nismo mogli da pronađemo nijedan nalog. Molim vas kreirajte novi da bi ste nastavili.",
    "NEW_ACCOUNT": "Novi nalog",
    "SELECTOR_SUBTITLE": "Napravite novi nalog",
    "API": {
      "SUCCESS_MESSAGE": "Nalog je uspešno kreiran",
      "EXIST_MESSAGE": "Nalog već postoji",
      "ERROR_MESSAGE": "Nije moguće se povezati sa Woot serverom, pokušajte ponovo kasnije"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Ime firme",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Pošalji",
      "CANCEL": "Otkaži"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "View all shortcuts",
    "TITLE": {
      "OPEN_CONVERSATION": "Otvoren razgovor",
      "RESOLVE_AND_NEXT": "Reši i idi na sledeći",
      "NAVIGATE_DROPDOWN": "Navigacija stavkama padajućeg menija",
      "RESOLVE_CONVERSATION": "Reši razgovor",
      "GO_TO_CONVERSATION_DASHBOARD": "Idi na radnu tablu razgovora",
      "ADD_ATTACHMENT": "Dodaj prilog",
      "GO_TO_CONTACTS_DASHBOARD": "Idi na radnu tablu kontakata",
      "TOGGLE_SIDEBAR": "Prikaži bočnu traku",
      "GO_TO_REPORTS_SIDEBAR": "Idi na bočnu traku izveštaja",
      "MOVE_TO_NEXT_TAB": "idi na sledeću karticu u spisku razgovora",
      "GO_TO_SETTINGS": "Idi na podešavanja",
      "SWITCH_TO_PRIVATE_NOTE": "Prebaci se na privatnu belešku",
      "SWITCH_TO_REPLY": "Prebaci se na odgovor",
      "TOGGLE_SNOOZE_DROPDOWN": "Uključite padajućim menijom odlaganja",
      "AI_ASSIST_MENU": "AI pomoć",
      "AI_ASSIST_GRAMMAR": "Ispravi gramatiku",
      "AI_ASSIST_UNIFY_LANG": "Ujednači jezik poruke"
    }
  }
}
